import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Title } from '~/components';
import styles from './PartnersIntro.scss';

export const PartnersIntro = ({
  shopName,
  partnerTitle = '',
  description,
  partnerName = null,
  title,
}) => {
  if (title?.length && !partnerName) {
    return (
      <Fragment>
        <Title className={styles.PartnersIntroTitle}>{title}</Title>
        <section className={styles.PartnersIntro}>
          <p>{description}</p>
        </section>
      </Fragment>
    );
  }
  return (
    <Fragment>
      {partnerName ? (
        <Title
          className={styles.PartnersIntroTitle}
        >{`${partnerName} is your ${partnerTitle} from ${shopName}`}</Title>
      ) : (
        <Title
          className={styles.PartnersIntroTitle}
        >{`Choose a ${partnerTitle} from ${shopName}`}</Title>
      )}
      <section className={styles.PartnersIntro}>
        <p>{description}</p>
      </section>
    </Fragment>
  );
};

PartnersIntro.propTypes = {
  shopName: PropTypes.string.isRequired,
  partnerTitle: PropTypes.string,
  partnerName: PropTypes.string,
  description: PropTypes.string.isRequired,
};
